//projectlab-web/src/main.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { I18nextProvider } from 'react-i18next';
import i18n from '@/i18n';
import App from './App';
import { AuthProvider } from '@/context/AuthContext';
import './styles/globals.css';
import { createLogger } from './lib/logger';

const log = createLogger('Main');
log.info('ProjectLab v0.1.0 starting', {
  mode: import.meta.env.MODE,
  url: import.meta.env.VITE_APP_URL,
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 10,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        log.warn('Query retry', { failureCount, error });
        return failureCount < 2;
      },
    },
    mutations: {
      onError: (error) => {
        log.error('Mutation error', error);
      },
    },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('[ProjectLab] #root element not found in DOM');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <App />
            <Toaster
              position="top-right"
              gutter={8}
              containerStyle={{ top: 72 }}
              toastOptions={{
                duration: 4000,
                style: {
                  background: 'var(--color-card)',
                  color: 'var(--color-text)',
                  border: '1px solid var(--color-border)',
                  borderRadius: '0.875rem',
                  fontFamily: 'var(--font-body)',
                  fontSize: '0.875rem',
                  boxShadow: 'var(--shadow-md)',
                  padding: '12px 16px',
                },
                success: {
                  iconTheme: { primary: 'var(--color-success)', secondary: 'white' },
                },
                error: {
                  iconTheme: { primary: 'var(--color-error)', secondary: 'white' },
                  duration: 6000,
                },
              }}
            />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </I18nextProvider>
  </React.StrictMode>
);
